import { BlocksTextLink } from 'blocks-nextjs/blocks-web-components/components/text-link/text-link';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';

export const CatTextLink = createComponent({ react: React, tagName: 'cat-text-link', elementClass: BlocksTextLink });
